import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const StatusReviewForSaleIcon: FC<IconProps> = ({ size = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path stroke="#A0A1AD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.31 17.75 7.06 20l-2.25-2.25H2V4.25h18V9M6.5 13.25h3.38M6.5 8.75h6.75"/>
    <path fill="#CC7400" fillRule="evenodd" d="M18 12a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3.37 3.83a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0Zm4.34 4.34a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0ZM21 15a.7.7 0 0 1 0 1l-5 5a.7.7 0 0 1-1-1l5-5a.7.7 0 0 1 1 0Z" clipRule="evenodd"/>
  </svg>
)

export default StatusReviewForSaleIcon
